import angular from 'angular'
import './drop.service'
import './edit/edit.controller'
import './translation/translation.controller'
import './waitlist/waitlist.controller'
import './waitlist/waitlist.service'

angular
  .module('pub.drop', [
    'pub.drop.edit',
    'pub.drop.service',
    'pub.drop.translation',
    'pub.drop.waitlist',
  ])
  .controller('DropCtrl', DropCtrl)

/** @ngInject */
function DropCtrl($rootScope, $scope, $state, $stateParams, DropsService) {
  $rootScope.page = 'page'
  var vm = this
  vm.loading = true
  vm.items = []
  vm.sort = ['Date: Newest', 'Date: Oldest']
  vm.msgErrorBool = false
  vm.sortType = 'ts-drp-desc'
  vm.sortType2 = 'ts-drp-desc'
  vm.sortReverse = false
  vm.sortReverse2 = false
  vm.title = ''

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 20
    vm.currentPage = 20
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPagination2() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.perPage2 = 20
    vm.currentPage2 = 20
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  reloadPagination()
  reloadPagination2()

  listUnpublished(1)
  listPublished(1)

  var tab = localStorage.getItem('drops')
  if (tab !== null) {
    if (tab === 'unpublished') {
      $('#published').removeClass('active')
      $('#unpublished').addClass('active')
      $('#unpublishedtab').addClass('active')
    } else if (tab === 'published') {
      $('#unpublished').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    }
  } else {
    $('#unpublished').addClass('active')
    $('#unpublishedtab').addClass('active')
  }

  vm.tabUnpublished = function () {
    $('#published').removeClass('active')
    $('#unpublished').addClass('active')
    localStorage.setItem('drops', 'unpublished')
  }

  vm.tabPublished = function () {
    $('#unpublished').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('drops', 'published')
  }

  vm.showModal = function () {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function () {
      $('#inputChannel').focus()
    })
  }

  var oldSortType
  function listUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 20
      vm.oldPage = vm.currentPage - 20
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    let sort = vm.sortType
    DropsService.listUnpublished(vm.oldPage, 20, sort).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i].st === 0) {
          result.results[i].status = 'Draft'
        } else if (result.results[i].st === 1) {
          result.results[i].status = 'Published'
        }

        if (result.results[i]['img-t']) {
          result.results[i]['img-t'] = `${$rootScope.urlS3}/drops/${result.results[i]['img-t']}`
        }

        if (result.results[i]['ch']) {
          if (!result.results[i]['img-t']) {
            result.results[i]['img-t'] =
              `${$rootScope.urlS3}/channels/${result.results[i]['ch']['img-t']}`
          }
          if (!result.results[i]['t']) {
            result.results[i]['t'] = result.results[i]['ch']['t']
          }
          if (!result.results[i]['txt']) {
            result.results[i]['txt'] = result.results[i]['ch']['txt']
          }
        }

        if (result.results[i]['s']) {
          let set = null
          // get set with lowest order `n`
          for (let j = 0; j < result.results[i]['s'].length; j++) {
            if (!set || result.results[i]['s'][j]['n'] < set['n']) {
              set = result.results[i]['s'][j]
            }
          }

          if (!result.results[i]['img-t']) {
            result.results[i]['img-t'] = `${$rootScope.urlS3}/sets/${set['img-t']}`
          }
          if (!result.results[i]['t']) {
            result.results[i]['t'] = set['t']
          }
          if (!result.results[i]['txt']) {
            result.results[i]['txt'] = set['txt']
          }

          let sets = []
          for (let j = 0; j < result.results[i]['s'].length; j++) {
            sets.push(result.results[i]['s'][j]['t'])
          }

          result.results[i]['sets'] = sets.join(', ')
        }
      }

      vm.sortType = oldSortType
      vm.items = result.results
      vm.loading = false
    })
  }

  var oldSortType2
  function listPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 20
      vm.oldPage2 = vm.currentPage2 - 20
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    let sort = vm.sortType2
    DropsService.listPublished(vm.oldPage2, 20, sort).then(function (result) {
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i].st === 0) {
          result.results[i].status = 'Draft'
        } else if (result.results[i].st === 1) {
          result.results[i].status = 'Published'
        }

        if (result.results[i]['img-t']) {
          result.results[i]['img-t'] = `${$rootScope.urlS3}/drops/${result.results[i]['img-t']}`
        }

        if (result.results[i]['ch']) {
          if (!result.results[i]['img-t']) {
            result.results[i]['img-t'] =
              `${$rootScope.urlS3}/channels/${result.results[i]['ch']['img-t']}`
          }
          if (!result.results[i]['t']) {
            result.results[i]['t'] = result.results[i]['ch']['t']
          }
          if (!result.results[i]['txt']) {
            result.results[i]['txt'] = result.results[i]['ch']['txt']
          }
        }

        if (result.results[i]['s']) {
          let set = null
          // get set with lowest order `n`
          for (let j = 0; j < result.results[i]['s'].length; j++) {
            if (!set || result.results[i]['s'][j]['n'] < set['n']) {
              set = result.results[i]['s'][j]
            }
          }

          if (!result.results[i]['img-t']) {
            result.results[i]['img-t'] = `${$rootScope.urlS3}/sets/${set['img-t']}`
          }
          if (!result.results[i]['t']) {
            result.results[i]['t'] = set['t']
          }
          if (!result.results[i]['txt']) {
            result.results[i]['txt'] = set['txt']
          }

          let sets = []
          for (let j = 0; j < result.results[i]['s'].length; j++) {
            sets.push(result.results[i]['s'][j]['t'])
          }

          result.results[i]['sets'] = sets.join(', ')
        }
      }

      vm.sortType2 = oldSortType2
      vm.items2 = result.results
      vm.loading = false
    })
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    listUnpublished(newPage)
  }

  vm.pageChanged2 = function (newPage) {
    vm.sortType2 = oldSortType
    listPublished(newPage)
  }

  vm.saveDrop = function () {
    if (vm.title === '' || vm.title === undefined) {
      vm.msgError = 'Title: non zero value required'
      vm.msgErrorBool = true
      return
    }
    if (vm.title.length <= 2) {
      vm.msgError = 'Title: needs at least 3 characters'
      vm.msgErrorBool = true
      return
    }
    $('#myModal').modal('hide')
    $('#myModal').on('hidden.bs.modal', function () {
      DropsService.save({ t: vm.title }).then(function (result) {
        $state.go('pub.drops.edit', { id: result.results.id })
      })
    })
  }

  vm.publish = function (state, item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want publish this drop',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          if (state) {
            DropsService.publish(item.id).then(
              function () {
                swal('Published', '', 'success')
                reloadPagination()
                reloadPagination2()
                vm.sortType = 'ts-drp-desc'
                vm.sortType2 = 'ts-drp-desc'
                listUnpublished(1)
                listPublished(1)
              },
              function (err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }
                swal({
                  title: 'Drop Incomplete',
                  text: html,
                  html: true,
                })
              },
            )
          } else {
            DropsService.unpublish(item.id).then(function () {
              swal('Unpublish', '', 'success')
              reloadPagination()
              load(1)
            })
          }
        }
      },
    )
  }

  vm.sort = function (type) {
    vm.sortReverse = !vm.sortReverse
    vm.sortCurtom = false
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    reloadPagination()
    load(1)
  }

  vm.sort2 = function (type) {
    vm.sortReverse2 = !vm.sortReverse2
    vm.sortCurtom2 = false
    if (vm.sortReverse2) {
      vm.sortType2 = type + '-asc'
    } else {
      vm.sortType2 = type + '-desc'
    }
    reloadPagination2()
    listPublished(1)
  }

  vm.deleteDrop = function (item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want delete this drop',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DropsService.remove(item.id).then(
            function () {
              swal('Deleted with success', '', 'success')
              reloadPagination()
              reloadPagination1()
              vm.sortType = 'ts-drp-desc'
              vm.sortType2 = 'ts-drp-desc'
              listUnpublished(1)
              listPublished(1)
            },
            function (err) {
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }
              swal({
                title: 'Drop Incomplete',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }

  vm.waitlist = function (item) {
    $state.go('pub.drops.waitlist', {
      parentId: $stateParams.parentId,
      id: item.id,
    })
  }
}
